import React, { useEffect } from 'react'
import { IDefaultEmergencyContact, TEmergencyContactSchema } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { EmergencyContactForm } from '../form-emergency-contact'
import { useDefaultEmergencyContactUpdate } from '../../../../../api/defaults/emergency-contact'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IUpdateEmergencyContactModalProps {
  defaultValues?: IDefaultEmergencyContact
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (
    data: IDefaultEmergencyContact[] | ((preData: IDefaultEmergencyContact[]) => IDefaultEmergencyContact[]),
  ) => void
}

export const UpdateEmergencyContactModal: React.FC<IUpdateEmergencyContactModalProps> = ({
  isOpen,
  onOpenChange,
  refreshList,
  defaultValues,
}) => {
  const { isLoading, updateEmergencyContact, isSuccess, returnData } = useDefaultEmergencyContactUpdate()
  const formId: string = React.useMemo(() => 'form-update-repairers', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = (data: TEmergencyContactSchema) => {
    updateEmergencyContact(data)
  }

  useEffect(() => {
    if (!isSuccess || !returnData) return

    refreshList((prevList) =>
      prevList.map((emergencyContact) => {
        if (emergencyContact.id !== returnData.id) return emergencyContact
        return returnData
      }),
    )
    handleClose()
  }, [isSuccess, returnData])

  const DrawerFooter = React.useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isLoading} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} intent="primary" type="submit" form={formId}>
          Update Repairer
        </Button>
      </ButtonGroup>
    )
  }, [isLoading, handleClose])

  if (!isOpen || !defaultValues) return null

  return (
    <ErrorBoundary>
      <Drawer
        isOpen={isOpen}
        onDrawerClose={handleClose}
        title="Edit Repairer"
        footerItems={<DrawerFooter />}
        canDismiss
      >
        <EmergencyContactForm formId={formId} defaultValues={defaultValues} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
